<template>
    <div class="wrapper">
        <div class="content-container">
            <div class="stingy-card">
                <h1>Whiskers and Wealth: A Purr-spective on Canadian Investment Strategies</h1>

                <iframe height="400" style="width: 100%;" scrolling="no" title="Oh Canada" src="https://codepen.io/Farah-Kamal/embed/zYeJBGr/8e1879dc70187877eef94721fe47b6dc?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
  See the Pen <a href="https://codepen.io/Farah-Kamal/pen/zYeJBGr/8e1879dc70187877eef94721fe47b6dc">
  Oh Canada</a> by Farah Kamal (<a href="https://codepen.io/Farah-Kamal">@Farah-Kamal</a>)
  on <a href="https://codepen.io">CodePen</a>.
</iframe>
                <p>Hello, Canadian investors! It's your feline financial guide, purring through the nuances of investment. Today, we unravel the yarn ball of Canadian investment strategies, with a keen eye on our local preferences and unique tax benefits. Let's leap in, shall we?</p>
                
                <h2>Local Markets: Comfortable but Limiting</h2>
                <p>Like a cat basking in the familiarity of its home, Canadians have traditionally gravitated towards investing in local markets. This preference, rooted in comfort and a sense of control, has often kept us curled up in the safety of our own economic backyard. However, this approach has sometimes meant missing out on the dynamic world of global investments. Below, a chart illustrating the growth of the TSX compared to international markets reveals the potential opportunities that may have slipped through our paws.</p>
                
                <p>Reflecting on the evolution of investment regulations, there was a time when Canadian investors faced a foreign investment limit in their RRSPs. This limit was initially set at only 10% in 1971, later increasing to 20% in the 1990s, and then 30%. This restriction was like a leash, limiting our explorations to predominantly Canadian investments and incurring taxes for those who dared to venture beyond these bounds. However, in a significant shift in 2005, these restrictions were completely lifted, unleashing a world of investment possibilities. Canadians now enjoy the freedom to diversify their portfolios globally, without the constraints of the past. This change has opened the door to a more varied and potentially rewarding investment landscape, akin to a cat discovering new and exciting territories beyond its familiar grounds.</p>

                <div class="tradingview-widget-container">
      <div id="tradingview-widget"></div>


                <h2>The Principal Residence Exemption: A Rare Treat</h2>
                <p>In Canada, owning a home is not just a matter of pride; it's a financially strategic move, thanks to the principal residence exemption. Unlike other investments taxed on capital gains, any profit made from selling your primary home is not taxed. This exemption is like a sunbeam in the Canadian tax environment, where most other gains are taxed. In a land often joked about for high taxes, this exemption stands out as a unique and valuable benefit, encouraging property investment and contributing significantly to an individual's wealth if one can afford it which sadly isn't always the case.  We are hoping that through our financial literacy programs that everyone has access to financial freedom in the way they choose.</p>
                
                <h2>Expanding Horizons Beyond the Local Litter Box</h2>
                <p>While our local market has its allure, diversification is key. Imagine adding a variety of international flavors to your investment diet. It's about more than just spreading risks; it's about tapping into growth opportunities that might be scarce in our Canadian market garden.</p>
                
                <h2>Embracing Global Opportunities with Feline Agility</h2>
                <p>As we gracefully navigate the future, let's remember that smart investing involves curiosity and exploration. It's about stepping out of our comfort zone and embracing global opportunities with the agility of a cat. The world is vast, and the opportunities for financial growth are abundant. Let's be nimble, let's be savvy, and let's find those perfect sunny spots of investment!</p>
            </div>
        </div></div>
    </div><br><br><br><br><br><br>
</template>


<script>
 import { onMounted, reactive } from 'vue';
  
  export default {
    setup() {
      const widgetConfig = reactive({
        colorTheme: "light",
        dateRange: "12M",
        showChart: true,
        locale: "en",
        largeChartUrl: "",
        isTransparent: false,
        showSymbolLogo: true,
        showFloatingTooltip: true,
        width: "350",
        height: "700",
        plotLineColorGrowing: "rgba(53, 28, 117, 1)",
        plotLineColorFalling: "rgba(142, 124, 195, 1)",
        gridLineColor: "rgba(240, 243, 250, 0)",
        scaleFontColor: "rgba(0, 0, 0, 1)",
        belowLineFillColorGrowing: "rgba(180, 167, 214, 0.12)",
        belowLineFillColorFalling: "rgba(142, 124, 195, 0.12)",
        belowLineFillColorGrowingBottom: "rgba(41, 98, 255, 0)",
        belowLineFillColorFallingBottom: "rgba(41, 98, 255, 0)",
        symbolActiveColor: "rgba(53, 28, 117, 0.12)",
        tabs: [
          {
            title: "Indices",
            symbols: [
              { s: "TSX:TSX", d: "S&P/TSX 60" },
              { s: "FOREXCOM:SPXUSD", d: "S&P 500" },
        {
          "s": "FOREXCOM:NSXUSD",
          "d": "NASDAQ 100 - US Tech Stocks"
        },
        {
          "s": "FOREXCOM:DJI",
          "d": "Dow Jones - 30 Broadbased US stocks"
        },
        {
          "s": "INDEX:NKY",
          "d": "Japan's stock market"
        },
        {
          "s": "INDEX:DEU40",
          "d": "Germany's stock market"
        },
        {
          "s": "FOREXCOM:UKXGBP",
          "d": "UK's Stock Market"
        },
  
        {
          "s": "NASDAQ:UAE",
          "d": "United Arab Emirates"
        },
          
             
            ],
            originalTitle: "Indices"
          },
      
        
          {
            title: "FX Rates",
            symbols: [
              { s: "FX:USDCAD", d: "USD to CAD" },
              { s: "FX:EURCAD", d: "EUR to CAD" },
              { s: "FX:GBPCAD", d: "GBP to CAD" },
              { s: "FX:AUDCAD", d: "AUD to CAD" },
            
           
             
            ],
            originalTitle: "Forex"
          },
         
        ]
      });
  
      onMounted(() => {
        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js';
        script.async = true;
        script.innerHTML = JSON.stringify(widgetConfig);
  
        document.getElementById('tradingview-widget').appendChild(script);
      });
  
      return {
        widgetConfig,
      };
    },
  };
</script>


<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content-container {
  max-width: 100%; /* Ensure it does not exceed the viewport width */
  background-color: #4A148C;
  color: black;
  padding: 20px;
  border-radius: 20px;
  overflow: hidden;
}

.stingy-card {
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
}

.tradingview-widget-container {
  width: 100%; /* Make the TradingView widget container responsive */
  margin: 0 auto; /* Center the container */
}

@media (max-width: 768px) {
  .stingy-card {
    padding: 10px; /* Reduce padding on smaller screens */
  }

  .content-container, .tradingview-widget-container {
    padding: 10px;
  }
}
</style>
